import {
  IAutocompleteOption,
  ISelectOption,
} from "src/shared/types/field.types";
import { EClientRegion } from "src/shared/types/partner.types";

export const clientRegionOptionsBY: IAutocompleteOption<EClientRegion>[] = [
  { name: "Минск", value: EClientRegion.BYMinsk },
  { name: "Регион", value: EClientRegion.Region },
];
export const clientRegionOptionsRU: IAutocompleteOption<EClientRegion>[] = [
  { name: "Москва", value: EClientRegion.RUMoscow },
  { name: "Регион", value: EClientRegion.Region },
];

export const notSelectedOption: ISelectOption<""> = {
  name: "Не выбрано",
  value: "",
};
